module.exports = "../../static/img/vk.0e3b420.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/vk.png
// module id = alar
// module chunks = 1